import styled from "styled-components";
import { InputTextarea as PRInputTextArea, InputTextareaProps } from "primereact/inputtextarea";
import React from "react";

const InputTextAreaWrapper = (props: InputTextareaProps) => (
  <PRInputTextArea className={props.className} {...props} />
);

export const InputTextArea = styled(InputTextAreaWrapper)`
  :enabled:focus {
    box-shadow: none;
    border-color: ${({ theme }) => theme.colorTokens.blue100};
  }
  :enabled:hover {
    border-color: ${({ theme }) => theme.colorTokens.blue850};
  }
`;
